export const ApiUrl = {
  BASE: process.env.REACT_APP_ENDPOINT,
  VACACIONES: process.env.REACT_APP_ENDPOINT_VACACIONES,
  RECLUTAMIENTO_Y_SELECCION: process.env.REACT_APP_ENDPOINT_RECLUTAMIENTO_Y_SELECCION,
  CARGA_LEGAJO: process.env.REACT_APP_ENDPOINT_CARGA_DOCUMENTOS,
  ASISTENCIA: process.env.REACT_APP_ENDPOINT_ASISTENCIA,
};
